import { render, staticRenderFns } from "./ModalVersionDiff.vue?vue&type=template&id=7a32b1b2&"
import script from "./ModalVersionDiff.vue?vue&type=script&lang=js&"
export * from "./ModalVersionDiff.vue?vue&type=script&lang=js&"
import style0 from "./ModalVersionDiff.vue?vue&type=style&index=0&id=7a32b1b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports